import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";

const Dashboard = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subDropdownOpen, setSubDropdownOpen] = useState(null); // Manage sub-dropdown states
  // Toggle sub-dropdown based on index
  const toggleSubDropdown = (index) => {
    setSubDropdownOpen((prev) => (prev === index ? null : index)); // Open the clicked dropdown and close others
  };

  const [officeData, setOfficeData] = useState([]);

  const getOfficeData = async () => {
    const response = await fetch(`${api_url}/api/users/all-office-data`, {
      method: "POST",
      body: JSON.stringify({
        userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      setOfficeData(result.result);
    }
  };
  const [allEmpData, setAllEmpData] = useState([]);

  const getAllData = async () => {
    const response = await fetch(`${api_url}/api/users/get-users-employee`, {
      method: "POST",
      body: JSON.stringify({
        userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      setAllEmpData(result.result);
    }
  };
  const [ITCData, setITCData] = useState([]);
  const getITCData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-itc-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        setITCData(result.users);
      }
    } catch (error) {
      console.log("Something failed. Please try again.");
    }
  };

  const [GPFNRData, setGPFNRData] = useState([]);
  const getGPFNRData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-gpfnr-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        setGPFNRData(result.result);
      } else {
        setGPFNRData([]);
      }
    } catch (error) {
      console.log("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getAllData();
    getOfficeData();
    getITCData();
    getGPFNRData();
  }, []);

  return (
    <div className="container py-3 dashboard-manu">
      <div className="row">
        <div className="col-lg-4 mt-3">
          <Link
            to={"/dashboard/user_incometax"}
            className="card p-3 bg-success h-100"
          >
            <h4 className="text-white fw-bold">Income Tax</h4>
            <p>Total Office : {officeData && officeData.length}</p>
            <p>Total Employee : {allEmpData && allEmpData.length}</p>
            <p>Completed Work : {ITCData && ITCData.length}</p>
          </Link>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-secondary h-100">
            <h4 className="text-white fw-bold">Pension</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-primary h-100">
            <h4 className="text-white fw-bold">GPF Final</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-info h-100">
            <h4 className="text-white fw-bold">GIS </h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <Link
            to={"/dashboard/inter_district_transfer"}
            className="card p-3 bg-danger h-100"
          >
            <h4 className="text-white fw-bold">Inter District Transfer</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </Link>
        </div>
        <div className="col-lg-4 mt-3">
          <Link
            to={"/dashboard/gpf_non_refundable"}
            className="card p-3 bg-warning h-100"
          >
            <h4 className="text-dark fw-bold">GPF Non Refundable</h4>
            <p className="text-dark">
              Completed Work : {GPFNRData && GPFNRData.length}
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
